export default {
  district: [],
};
